// src/SelectionText.ts
var SelectionText = class {
  constructor(elm) {
    const { selectionStart, selectionEnd } = elm;
    this.elm = elm;
    this.start = selectionStart;
    this.end = selectionEnd;
    this.value = this.elm.value;
  }
  position(start, end) {
    const { selectionStart, selectionEnd } = this.elm;
    this.start = typeof start === "number" && !isNaN(start) ? start : selectionStart;
    this.end = typeof end === "number" && !isNaN(end) ? end : selectionEnd;
    this.elm.selectionStart = this.start;
    this.elm.selectionEnd = this.end;
    return this;
  }
  insertText(text) {
    this.elm.focus();
    this.elm.setRangeText(text);
    this.value = this.elm.value;
    this.position();
    return this;
  }
  getSelectedValue(start, end) {
    const { selectionStart, selectionEnd } = this.elm;
    return this.value.slice(
      typeof start === "number" && !isNaN(start) ? start : selectionStart,
      typeof end === "number" && !isNaN(end) ? start : selectionEnd
    );
  }
  getLineStartNumber() {
    let start = this.start;
    while (start > 0) {
      start--;
      if (this.value.charAt(start) === "\n") {
        start++;
        break;
      }
    }
    return start;
  }
  /** Indent on new lines */
  getIndentText() {
    const start = this.getLineStartNumber();
    const str = this.getSelectedValue(start);
    let indent = "";
    str.replace(/(^(\s)+)/, (str2, old) => indent = old);
    return indent;
  }
  lineStarInstert(text) {
    if (text) {
      const oldStart = this.start;
      const start = this.getLineStartNumber();
      const str = this.getSelectedValue(start);
      this.position(start, this.end).insertText(
        str.split("\n").map((txt) => text + txt).join("\n")
      ).position(oldStart + text.length, this.end);
    }
    return this;
  }
  lineStarRemove(text) {
    if (text) {
      const oldStart = this.start;
      const start = this.getLineStartNumber();
      const str = this.getSelectedValue(start);
      const reg = new RegExp(`^${text}`, "g");
      let newStart = oldStart - text.length;
      if (!reg.test(str)) {
        newStart = oldStart;
      }
      this.position(start, this.end).insertText(
        str.split("\n").map((txt) => txt.replace(reg, "")).join("\n")
      ).position(newStart, this.end);
    }
  }
  /** Notify any possible listeners of the change */
  notifyChange() {
    const event = new Event("input", { bubbles: true, cancelable: false });
    this.elm.dispatchEvent(event);
  }
};

export {
  SelectionText
};
//# sourceMappingURL=chunk-W2BRCVY6.mjs.map